/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Clients API
 * AV Services Clients management API
 * OpenAPI spec version: 1.0
 */

/**
 * Dashboard configuration object
 */
export type DashboardConfigProperty = { [key: string]: unknown };
